import { enforce, test } from "vest";
import { trans } from "@/service/i18n/i18n";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";

export function createRatingFieldValidationSuite(
  definition: TextField,
  formValue: any,
): void {
  const value = (accessFormFieldValue(definition, formValue) as string) ?? "";

  if (definition.required) {
    test(createFieldName(definition), trans("form_validation.required"), () => {
      enforce(value).isNumber();
    });
  }

  if (definition.value) {
    test(
      createFieldName(definition),
      trans("form_validation.invalid_format"),
      () => {
        enforce(value).isBetween(1, 5);
      },
    );
  }
}
